<template>
  <!--Est-ce utilisé ?-->
  <div>
    <article
      v-for="(cat, index) in item"
      :key="cat.uid"
      class="rc-grid-unit rc-category"
    >
      <div v-if="isStacked" class="rc-stack-effect"></div>

      <header>
        <h3 class="h4 text-center">
          <router-link
            :to="{
              name: 'catalog.category.detail',
              params: { uid: cat.uid, locale: $i18n.locale }
            }"
            class="stretched-link"
            :aria-label="
              $t('catalog.link_label.short', {
                title: cat.name
              })
            "
            @keydown.tab.exact="onKeydownTab"
            @keydown.shift.tab="onKeydownShiftTab"
          >
            {{ cat.name }}
          </router-link>
        </h3>
      </header>
    </article>
  </div>
</template>

<script>
export default {
  name: "RcGridCategoryUnit",
  props: {
    item: {
      type: Array,
      default: () => {}
    },
    locked: {
      type: Boolean,
      default: false
    },
    isStacked: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  emits: ["keydownTab", "keydownShiftTab"],

  methods: {
    onKeydownTab(e) {
      this.$emit("keydownTab", e);
    },
    onKeydownShiftTab(e) {
      this.$emit("keydownShiftTab", e);
    }
  }
};
</script>

<style lang="scss">
.rc-grid-unit.rc-category {
  background: var(--plum);
  padding: 1.5rem 0;
  border-radius: 4px;
  a {
    color: var(--bs-white);
  }
}
</style>
